import { breakpoints } from '@unistocks/shared/breakpoints';

// note order is important!
// earlier defined = less important

export const media = {
  'max-xxxl': { maxWidth: breakpoints['xxxl'] },
  'max-xxl': { maxWidth: breakpoints['xxl'] },
  'max-xl': { maxWidth: breakpoints.xl },
  'max-lg': { maxWidth: breakpoints.lg },
  'max-md': { maxWidth: breakpoints.md },
  'max-sm': { maxWidth: breakpoints.sm },
  'max-xs': { maxWidth: breakpoints.xs },
  'max-xxs': { maxWidth: breakpoints['xxs'] },
  xxs: { minWidth: breakpoints['xxs'] },
  xs: { minWidth: breakpoints.xs },
  sm: { minWidth: breakpoints.sm },
  md: { minWidth: breakpoints.md },
  lg: { minWidth: breakpoints.lg },
  xl: { minWidth: breakpoints.xl },
  xxl: { minWidth: breakpoints['xxl'] },
  xxxl: { minWidth: breakpoints['xxxl'] }
} as const;
